import $ from "jquery";

const nextButton = $(".testimonials-slider-button-next"),
  prevButton = $(".testimonials-slider-button-prev");

nextButton.on("click", function () {
  if (!$(this).hasClass("disabled")) {
    let activeSlide = $(".testimonials-item.active");
    let nextSlide = $(".testimonials-item.active").next();
    let currentItemNumber = $(".testimonials-slider-pagination .current"),
      currentItemNumberText = parseInt(currentItemNumber.text());
    activeSlide.removeClass("active").addClass("hidden");
    if (nextSlide.prev().length != 0 && prevButton.hasClass("disabled")) {
      prevButton.removeClass("disabled");
      prevButton.attr("aria-hidden", "false");
    }
    currentItemNumber.html(currentItemNumberText + 1);
    if (nextSlide.next().length != 0) {
      nextSlide.addClass("active").removeClass("hidden");
    } else {
      nextSlide.addClass("active").removeClass("hidden");
      $(this).addClass("disabled");
      $(this).attr("aria-hidden", "true");
    }
  }
});
prevButton.on("click", function () {
  if (!$(this).hasClass("disabled")) {
    let activeSlide = $(".testimonials-item.active");
    let prevSlide = $(".testimonials-item.active").prev();
    let currentItemNumber = $(".testimonials-slider-pagination .current"),
      currentItemNumberText = parseInt(currentItemNumber.text());
    if (prevSlide.next().length != 0 && nextButton.hasClass("disabled")) {
      nextButton.removeClass("disabled");
      nextButton.attr("aria-hidden", "false");
    }
    currentItemNumber.html(currentItemNumberText - 1);
    activeSlide.removeClass("active").addClass("hidden");
    if (prevSlide.prev().length != 0) {
      prevSlide.addClass("active").removeClass("hidden");
    } else {
      prevSlide.addClass("active").removeClass("hidden");
      $(this).addClass("disabled");
      $(this).attr("aria-hidden", "true");
    }
  }
});

const testimonialText = $(".customer-testimonials .testimonials-text");
testimonialText.each(function () {
  let target = $(this).find("a").attr("target");
  if (target === "_blank") {
    $(this).find("a").attr("aria-label", "Open in new tab");
  }
});
